import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import SolutionsTabs from "../components/SolutionsTabs";
import { WhyChoose, Partners, Clients, Testimonials, CTABanner } from "../components/Sections";

const Home = () => (
  <div className="bg-white">
    <Header/>
    <Hero/>
    <SolutionsTabs/>
    <Partners/>
    <WhyChoose/>
    <Clients/>
    <Testimonials/>
    <CTABanner/>
    <Footer/>
  </div>
);

export default Home;
